import {
  copyBrowserText,
  printBrowserText,
  shareBrowserText,
} from '../sharing/browserSharing';
import { buildFinalizedText } from './journeyBriefModel';

const asArray = (value) => Array.isArray(value) ? value : [];
const cleanText = (value = '') => String(value || '').trim();

export const buildFinalizedRevisionSharePayload = (revision) => {
  if (!cleanText(revision?.revisionId) || !revision?.finalizedAt) {
    throw new Error('Choose a finished brief version to share.');
  }
  const recipientContent = {
    title: cleanText(revision?.recipientContent?.title || revision?.title),
    header: revision?.recipientContent?.header || revision?.reportHeader || null,
    sections: asArray(revision?.recipientContent?.sections).map((section) => ({
      id: cleanText(section?.id),
      title: cleanText(section?.title),
      text: String(section?.text || '').trim(),
    })).filter((section) => section.title && section.text),
  };
  const text = buildFinalizedText(recipientContent);
  if (!text) throw new Error('This finished brief has no shareable content.');
  return { title: recipientContent.title || 'Meeting brief', text };
};

const therapyPrepBrowserShareAdapter = Object.freeze({
  id: 'therapy_prep_browser_share_v1',
  buildPayload: buildFinalizedRevisionSharePayload,
  copy: (payload, dependencies) => copyBrowserText({ ...payload, ...dependencies }),
  share: (payload, dependencies) => shareBrowserText({ ...payload, ...dependencies }),
  print: (payload, dependencies) => printBrowserText({ ...payload, ...dependencies }),
});

const JOURNEY_SHARING_ADAPTERS = Object.freeze({
  [therapyPrepBrowserShareAdapter.id]: therapyPrepBrowserShareAdapter,
});

export const getJourneySharingAdapter = (adapterId) => {
  const adapter = JOURNEY_SHARING_ADAPTERS[cleanText(adapterId)];
  if (!adapter) throw new Error('This Journey sharing option is not available.');
  return adapter;
};
